export default __webpack_public_path__ + "static/media/forest.92066e23.png";